import t from "./arrayLikeToArray.mjs";
function a(r) {
  if (Array.isArray(r))
    return t(r);
}
export {
  a as default
};
//# sourceMappingURL=arrayWithoutHoles.mjs.map
